import type { Dict } from "../core.js";
import type { overview as vi } from "../vi/overview.js";

export const overview: Dict<typeof vi> = {
  title: "Overview",
  subtitle: "Status and trends across the whole ecosystem.",
  healthFailed: "Couldn't read hub health.",
  audienceFailed: "Couldn't read user numbers.",
  p1Banner: "{count} unresolved P1 incident(s). Acknowledged items still count — acknowledging doesn't make the issue go away.",

  "health.title": "Hub health",
  "health.status": "Status",
  "health.ok": "Healthy",
  "health.degraded": "Degraded",
  "health.database": "Database",
  "health.dbOk": "Connected",
  "health.dbDown": "Unreachable",
  "health.latency": "Latency",

  "business.title": "Business",
  "business.audienceLink": "View user details",
  "business.sumNote": "The three cards below SUM all apps (a person in two apps is counted twice) — per-app numbers are right below.",
  "business.newUsers30d": "New users (30 days)",

  "pending.title": "The other three groups aren't measured yet.",
  "pending.bodyBefore":
    "Subscriptions, revenue, usage and customer feedback need more sources and more slices. They will appear here with a quality label — « Estimated », « Stale », « Unsupported » — and will never show",
  "pending.bodyAfter": "when the truth is that it hasn't been measured.",
};
